import React from "react";

import TagManager from "react-gtm-module";
import { ConfigurationEnvironmentEnum } from "../../../models";
import { useAppConfiguration } from "./configuration.app.hook";
import { StyledAppConfigurationContainer } from "./configuration.app.styles";

interface AppConfigurationWrapperProps {
  children: React.ReactNode;
}

const AppConfigurationWrapper: React.FC<AppConfigurationWrapperProps> = ({ children }) => {
  const { appConfiguration } = useAppConfiguration();

  // Initialize Google Tag Manager
  if (appConfiguration?.environment === ConfigurationEnvironmentEnum.PRODUCTION) {
    TagManager.initialize({ gtmId: "GTM-N4ZB5V4H" });
  }

  return (
    <>
      {children}
      {appConfiguration?.environment === ConfigurationEnvironmentEnum.DEVELOPMENT && (
        <StyledAppConfigurationContainer />
      )}
    </>
  );
};

export default AppConfigurationWrapper;
